module.exports = __webpack_public_path__ + "img/mind_icon_number_9.66f3e375.png";